/* Modulo Logo Cloud Dual — measure-and-clone for BOTH rows so each loops
   cleanly at its own speed. Same strategy as logo-cloud, applied per track. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function getGap(el) {
    var s = getComputedStyle(el);
    var raw = s.columnGap || s.gap || '0';
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  function measureCycle(originals, gap) {
    var w = 0;
    for (var i = 0; i < originals.length; i++) {
      w += originals[i].getBoundingClientRect().width;
    }
    return w + gap * originals.length;
  }

  function cloneSet(track, originals) {
    for (var i = 0; i < originals.length; i++) {
      var c = originals[i].cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('role');
      track.appendChild(c);
    }
  }

  function initTrack(track, viewport) {
    if (track.dataset.moduloLcdReady === '1') return;
    var originals = Array.prototype.slice.call(track.children);
    if (originals.length === 0) return;

    var gap = getGap(track);
    var cycle = measureCycle(originals, gap);
    if (cycle <= 0) return;

    var copies = Math.max(2, Math.ceil((viewport + cycle) / cycle));
    for (var i = 0; i < copies; i++) cloneSet(track, originals);

    track.style.setProperty('--modulo-lcd-cycle-width', cycle + 'px');
    track.dataset.moduloLcdReady = '1';
  }

  function init(el) {
    var viewport = el.offsetWidth || document.documentElement.clientWidth;
    var tracks = el.querySelectorAll('.modulo-lcd__track');
    for (var i = 0; i < tracks.length; i++) initTrack(tracks[i], viewport);
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-lcd]', init);
    } else {
      var els = document.querySelectorAll('[data-modulo-lcd]');
      for (var i = 0; i < els.length; i++) init(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  var t = null;
  window.addEventListener('resize', function () {
    if (t) clearTimeout(t);
    t = setTimeout(function () {
      var els = document.querySelectorAll('[data-modulo-lcd]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var tracks = el.querySelectorAll('.modulo-lcd__track');
        for (var k = 0; k < tracks.length; k++) {
          var track = tracks[k];
          if (track.dataset.moduloLcdReady !== '1') continue;
          var needed = el.offsetWidth * 2;
          var safety = 0;
          while (track.scrollWidth < needed && safety < 4) {
            var snap = Array.prototype.slice.call(track.children);
            for (var j = 0; j < snap.length; j++) {
              var c = snap[j].cloneNode(true);
              c.setAttribute('aria-hidden', 'true');
              c.removeAttribute('role');
              track.appendChild(c);
            }
            safety++;
          }
        }
      }
    }, 200);
  });
})();
